import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const changePassword = createAsyncThunk('changePassword', async ({ values }) => {
    try {
        const res = await axios({

            method: "PUT",
            url: process.env.REACT_APP_API_URL + 'change_password',
            data: {
                "old_password": values?.old_password,
                "new_password": values?.confirm_password,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})